// TODO: Properly export meta response type
import { MetaResponse } from '@genial/services/dist/models';

export const blankMetaResponse = (): MetaResponse => ({
  pagination: {
    page: 1,
    count: 0,
    hasNext: false,
    limit: 40,
    total: 0,
  },
});

export const fakeMetaResponse = (total: number): MetaResponse => ({
  pagination: {
    page: 1,
    count: total,
    hasNext: false,
    limit: total,
    total,
  },
});
